import { Button, Center, Checkbox, Grid, Loader, ScrollArea, Stack, Text } from "@mantine/core";
import { useState } from "react";
import { convertToDateTimeString } from "../../../helpers/dates";
import { getFullName } from "../../../helpers/stringHelper";
import { impressionIcons, impressionTranslationsShort } from "../../../models/enums/impression";
import type { Observation } from "../../../models/observation";
import { CheckboxCard } from "../../checkbox/card/CheckboxCard";

type ObservationImportModalProps = {
  observations?: Observation[];
  loading?: boolean;
  onClose?: (texts: string[]) => void;
};

export function ObservationImport({ onClose, observations = [], loading = false }: ObservationImportModalProps) {
  const [value, setValue] = useState<string[]>([]);

  const getValue = (o: Observation) => `(${impressionTranslationsShort[o.impression]}) ${o.text}`;

  const _onClose = () => {
    const selectedObservations = observations?.filter((o) => value.includes(o.id.toString()));
    onClose?.(selectedObservations.map((o) => getValue(o)));
  };

  return (
    <Stack mih="30%">
      {loading ? (
        <Center>
          <Loader size={32} />
        </Center>
      ) : (
        <>
          <ScrollArea.Autosize mah="80vh" scrollbars="y">
            <Checkbox.Group value={value} onChange={setValue} mb="md">
              <Grid align="stretch">
                {observations.map((o) => (
                  <Grid.Col key={o.id} span={6}>
                    <CheckboxCard value={o.id.toString()}>
                      <CheckboxCard.Title rightSection={impressionIcons[o.impression]}>
                        Beobachtung von «{getFullName(o.coach)}» am: {convertToDateTimeString(o.observed_at)}
                      </CheckboxCard.Title>
                      <CheckboxCard.Text>{o.text}</CheckboxCard.Text>
                    </CheckboxCard>
                  </Grid.Col>
                ))}
              </Grid>
            </Checkbox.Group>
          </ScrollArea.Autosize>

          {observations.length === 0 && (
            <Center>
              <Text>Keine Beobachtungen gefunden...</Text>
            </Center>
          )}
          <Button w="100%" onClick={() => _onClose()} disabled={value.length === 0}>
            {value.length} Beobachtungen importieren
          </Button>
        </>
      )}
    </Stack>
  );
}
